import NavigationFrame from "../components/NavigationFrame";
import DivcolMd1 from "../components/DivcolMd1";
import Emailiconframe from "../components/Emailiconframe";
import "./WwwmontyesimcomByHtmltod.css";
import  { Toaster } from 'react-hot-toast';


import Navigation1 from "../components/Navigation1";
const WwwmontyesimcomByHtmltod = () => {
  return (
    <div className="wwwmontyesimcom-by-htmltod">
      <Navigation1 />
      <NavigationFrame />
      <DivcolMd1 />
      <Emailiconframe />
      <Toaster />
    </div>
  );
};

export default WwwmontyesimcomByHtmltod;
